import DataRoomConfirmInterestModal from './DataRoomConfirmInterestModal.component';

export default DataRoomConfirmInterestModal;